/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/remove-alt': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#242424" d="M4.465 10.121l1.414 1.415L8 9.414l2.122 2.122 1.414-1.415L9.415 8l2.12-2.121-1.413-1.415L8 6.586 5.88 4.464 4.464 5.88 6.586 8l-2.121 2.121z"/>'
  }
})
